
import { defineComponent } from 'vue'

import { getAbbreviationFromUser } from '@/utils/get-abbreviation-from-user'

export default defineComponent({
  components: {},
  data: function () {
    return {
      window: window
    }
  },
  computed: {
    user() {
      return this.$auth.user
    }
  },
  methods: {
    getAbbreviationFromUser,
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    }
  }
})
